//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'UiTabs',
  props: {
    items: {
      type: Array,
      default() {},
      required: false,
    },
  },
  data() {
    return {
      activeTab: 0,
    }
  },
  computed: {
    loaditems() {
      return this.items
    },
  },
  methods: {
    activateTab(index) {
      this.activeTab = index
    },
  },
}
